/**
 * Binding operational status badge (active / inactive / archived).
 * Separate from agent/pack lifecycle badges (Design §19.4).
 */

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import type { StudioBindingStatus } from '@/types/aiStudioAgent';

const STATUS_CLASSES: Record<StudioBindingStatus, string> = {
  active: 'border-[var(--color-success)] text-[var(--color-success)]',
  inactive: 'border-[var(--color-warning)] text-[var(--color-warning)]',
  archived: 'border-[var(--color-border)] text-[var(--color-surface-text-secondary)]',
};

interface BindingStatusBadgeProps {
  status: StudioBindingStatus;
}

export const BindingStatusBadge: React.FC<BindingStatusBadgeProps> = ({ status }) => {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-block rounded-full border px-2 py-0.5 text-base ${STATUS_CLASSES[status]}`}
    >
      {t(`aiStudio.bindingStatus.${status}`)}
    </span>
  );
};
